// Extract sender name from "Name <email>" or plain email
export const getSenderName = (mailFrom = "") => {
  if (!mailFrom) return "Unknown";

  // If there is a quoted name, use it
  const nameMatch = mailFrom.match(/"([^"]+)"/);
  if (nameMatch) return nameMatch[1];

  // Otherwise, extract the email part if format is "Name <email>"
  const emailMatch = mailFrom.match(/<([^>]+)>/);
  const email = emailMatch ? emailMatch[1] : mailFrom;

  // Return the part before "@"
  return email.split("@")[0] || "Unknown";
};


// Clean email body only (NO truncate)
export const getBodyPreview = (bodyText = "") => {
  if (!bodyText) return "";

  return bodyText
    .replace(/\r?\n/g, " ")
    .replace(/>.*$/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

//for subject
export const cleanSubject = (subject = "") => {
    if (typeof subject !== "string") return "(No Subject)";

  return subject
    .replace(/^Re:\s*/i, "")
    .replace(/^Fwd:\s*/i, "")
    .trim();
};



//mail date helper
export const formatMailDate = (mailDate) => {
  if (!mailDate) return "";

  const date = new Date(mailDate);
  const now = new Date();

  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  if (isToday) {
    // 06:54 AM
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  // Dec 18
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
  });
};





//modal mail date 
export const formatModalMailDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const now = new Date();

    // Format absolute date: "Dec 18, 2025, 11:38 PM"
    const options = { 
        year: "numeric", 
        month: "short", 
        day: "numeric", 
        hour: "numeric", 
        minute: "2-digit", 
        hour12: true 
    };
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

    // Calculate relative time
    const diffMs = now - date;
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    let relative = "";
    if (diffSeconds < 60) relative = `${diffSeconds} seconds ago`;
    else if (diffMinutes < 60) relative = `${diffMinutes} minutes ago`;
    else if (diffHours < 24) relative = `${diffHours} hours ago`;
    else relative = `${diffDays} days ago`;

    return `${formattedDate} (${relative})`;
};



